import { render, staticRenderFns } from "./dict-edit.vue?vue&type=template&id=ba1c02ec&"
import script from "./dict-edit.vue?vue&type=script&lang=ts&"
export * from "./dict-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports